// return lower triangle matrix of given matrix
export function getLowerTriangle<T>(mat: T[][]): T[][] {
  const ret: T[][] = [];

  mat.slice(1).forEach((row, i) => {
    const newRow = mat[i + 1].slice(0, i + 1);
    ret.push(newRow);
  });

  return ret;
}

export function expand<T>(
  mat: T[][],
  rows: number,
  columns: number,
  fill: T
): void {
  // if mat is empty, different logic is needed
  if (mat.length === 0) {
    mat.push([]);
    // add columns
    for (let j = 0; j < columns; j++) {
      mat[0].push(fill);
    }
    // add rows - 1
    for (let i = 0; i < rows - 1; i++) {
      mat.push(Array(mat[0].length + columns).fill(fill));
    }
    return;
  }
  // add columns
  for (let i = 0; i < mat.length; i++) {
    for (let j = 0; j < columns; j++) {
      mat[i].push(fill);
    }
  }
  // add rows
  for (let i = 0; i < rows; i++) {
    mat.push(Array(mat[0].length).fill(fill));
  }
}

export function expandWithArray<T>(
  mat: Array<T>[][],
  rows: number,
  columns: number
): void {
  // if mat is empty, different logic is needed
  if (mat.length === 0) {
    // add rows
    for (let i = 0; i < rows; i++) {
      const t = [];
      for (let j = 0; j < columns; j++) {
        t.push([]);
      }
      mat.push(t);
    }
    return;
  }
  // add columns
  for (let i = 0; i < mat.length; i++) {
    for (let j = 0; j < columns; j++) {
      mat[i].push([]);
    }
  }
  // add rows
  for (let i = 0; i < rows; i++) {
    const t = [];
    for (let j = 0; j < mat[0].length; j++) {
      t.push([]);
    }
    mat.push(t);
  }
}
